import { Component } from "@angular/core";
import { IDriver } from "@app/interfaces/IDriver";
import { IGeofence } from "@app/interfaces/IGeofences";
import { IVehicle } from "@app/interfaces/IVehicle";
import { DriverService } from "@app/services/driver.service";
import { GeofenceService } from "@app/services/geofence.service";
import { VehicleService } from "@app/services/vehicle.service";
import "./site-search.component.scss";

@Component({
    selector: "site-search",
    template: require("./site-search.component.html")
})
export class SiteSearchComponent {
    searchValue: string;

    // --

    loading: boolean;
    dataLoaded: boolean;

    vehicles: IVehicle[];
    geofences: IGeofence[];
    drivers: IDriver[];

    matchedVehicles: IVehicle[];
    matchedGeofences: IGeofence[];
    matchedDrivers: IDriver[];

    constructor(
        private readonly vehicleService: VehicleService,
        private readonly driverService: DriverService,
        private readonly geofenceService: GeofenceService) {
    }

    searchValueUpdated() {


        if (!this.searchValue) {
            this.matchedVehicles = [];
            this.matchedDrivers = [];
            this.matchedGeofences = [];
            return;
        }

        if (!this.dataLoaded) {
            this.loadData()?.then(() => { this.searchValueUpdated() });
            return;
        }

        this.matchedVehicles = this.vehicleService.searchVehicles(this.vehicles, this.searchValue);


        this.matchedDrivers = this.driverService.searchDrivers(this.drivers, this.searchValue.toLowerCase());


        this.matchedGeofences = this.geofenceService.searchGeofences(this.geofences, this.searchValue);

    }

    loadData(): angular.IPromise<any> {
        if (this.loading || this.dataLoaded) {
            return;
        }

        this.loading = true;

        const vehiclePromise = this.vehicleService.getVehicles({});
        const driverPromise = this.driverService.getDrivers({});
        const geofencePromise = this.geofenceService.getGeofences({ unsafe: true });

        vehiclePromise.then(vehicles => { this.vehicles = vehicles; });
        driverPromise.then(drivers => { this.drivers = drivers; });
        geofencePromise.then(geofences => { this.geofences = geofences; });

        return vehiclePromise.then(() => {
            driverPromise.then(() => {
                geofencePromise.then(() => {
                    this.loading = false;
                    this.dataLoaded = true;
                })
            })
        })
    }

    // --

}
